// extracted by mini-css-extract-plugin
export var lg = "_1u-4";
export var md = "_1u-3";
export var sm = "_1u-2";
export var xs = "_1u-1";
export var xxs = "_1u-0";